import Vue from 'vue'
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend
} from 'vee-validate'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'
import {
  required,
  email,
  double,
  confirmed,
  numeric,
  max,
  max_value,
  min,
  min_value,
  alpha_num
} from 'vee-validate/dist/rules'
// rules avalaibles
extend('email', email)
extend('required', required)
extend('confirmed', confirmed)
extend('double', double)
extend('numeric', numeric)
extend('max', max)
extend('max_value', max_value)
extend('min', min)
extend('min_value', min_value)
extend('alpha_num', alpha_num)
extend('url', {
  validate(value) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator
    return pattern.test(value)
  },
  message: 'Please enter a valid link.'
})
extend('no_asterisk', {
  message: '* is not allowed',
  validate(value) {
    return !/\*/.test(value)
  }
})
extend('phone', {
  validate(value) {
    return /^\+?[0-9]{1,20}$/.test(value)
  },
  message:
    'The field must be a valid phone number (e.g. +123456789) and max 20 characters'
})
extend('decimals', {
  validate: (value, { fix = '*', separator = '.' }) => {
    if (value == null || value === '') {
      return false
    }

    if (Array.isArray(value)) {
      return value.every((val) => this(val, { fix, separator }))
    }

    // if is 0.
    if (Number(fix) === 0) {
      return /^-?\d*$/.test(value)
    }

    const regexPart = fix === '*' ? '+' : `{1,${fix}}`
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    )

    if (!regex.test(value)) {
      return false
    }

    const parsedValue = parseFloat(value)
    return parsedValue === parsedValue
  },
  params: ['fix', 'separator']
})
// end rules

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

localize({
  en,
  es
})

localize('en', {
  ...en,
  messages: {
    ...en.messages,
    decimals: (field, { fix }) =>
      `The field ${field} allows a maximum of ${fix} decimals`
  }
})

localize('es', {
  ...es,
  messages: {
    ...es.messages,
    decimals: (field, { fix }) =>
      `El campo "${field}" permite máximo ${fix} decimales`
  }
})
